import { apiService } from "../../../services/apiService";
import { apiServiceConstants } from "../../../constants";
import { utilService } from "../../../services/utilService";


const providerAcceptData = async (params: any): Promise<any> => {
  const resApi = await apiService
    .apiCall(
      `ems/emergency-provider-alert-response/?reg_code=${utilService.getNetwork()}&time_zone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as any;
      const result: any = {
        isSuccess: response.isSuccess,
        status: response.status,
        message: response.message,
      };
      return result;
    })
    .catch((error) => {
      const result: any = {
        isSuccess: false,
        message: error.message,
        status: error.status,
      };
      return result;
    });
  return resApi;
};

export const setPatientAcceptanceService = {
  providerAcceptData,
};
